<template>
  <vs-popup class="rm-price-change-request-create-popup"
            id="popup"
            title="RAW MATERIAL PRICE CHANGE REQUEST"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit()" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/3 md:mb-0">
              <ValidationProvider vid="is_volume_price_tiers" name="is_volume_price_tiers" rules="" v-slot="{ errors }">
                <small class="label">are there price volume tiers?</small>
                <vs-switch disabled v-model="form.is_volume_price_tiers" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/4 w-full md:mb-0">
              <ValidationProvider vid="proposed_date" name="proposed_date" rules="required" v-slot="{ errors }">
                <small class="label">Proposed date</small>
                <vs-input disabled v-model="form.proposed_date" type="text" name="proposed_date" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
          <div v-if="form.is_volume_price_tiers" v-for="(prices_tier, index) in form.prices_tier" :key="index">
            <div class="vx-row mb-3" >
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider :vid="index+'min_order_quantity'" :name="index+'min_order_quantity'" :rules="validate_prices_tier(index)" v-slot="{ errors }">
                  <small class="label">Min order quantity</small>
                  <vs-input disabled v-model="prices_tier.min_order_quantity" type="number" name="min_order_quantity" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider :vid="index+'max_order_quantity'" :name="index+'max_order_quantity'" :rules="validate_max_price_tier(index)" v-slot="{ errors }">
                  <small class="label">Max order quantity</small>
                  <vs-input disabled v-model="prices_tier.max_order_quantity" type="number" name="max_order_quantity" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider :vid="index+'price_per_unit'" :name="index+'price_per_unit'" rules="required" v-slot="{ errors }">
                  <small class="label">Price per unit</small>
                  <vs-input disabled v-model="prices_tier.price_per_unit" type="text" name="price_per_unit" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider :vid="index+'payment_terms'" :name="index+'payment_terms'" rules="required" v-slot="{ errors }">
                  <small class="label">Payment terms (Days)</small>
                  <vs-input disabled v-model="prices_tier.payment_terms" type="text" name="payment_terms" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/6 w-full md:mb-0">
                <ValidationProvider :vid="index+'delivery_terms'" :name="index+'delivery_terms'" rules="required" v-slot="{ errors }">
                  <small class="label">Delivery terms (Days)</small>
                  <vs-input disabled v-model="prices_tier.delivery_terms" type="text" name="delivery_terms" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div class="vx-row mb-3" v-if="!form.is_volume_price_tiers">
            <div class="vx-col md:w-1/4 w-full md:mb-0">
              <ValidationProvider vid="old_data_price_per_unit" name="old_data_price_per_unit" rules="required" v-slot="{ errors }">
                <small class="label text-primary">Current live pricing</small>
                <vs-input disabled :value="old_data.prices.price_per_unit? old_data.prices.price_per_unit: 0" type="text" name="old_data_price_per_unit" class="w-full text-danger"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/4 w-full md:mb-0">
              <ValidationProvider vid="price_per_unit" name="price_per_unit" rules="required" v-slot="{ errors }">
                <small class="label">Proposed price per unit</small>
                <vs-input disabled v-model="form.prices.price_per_unit" type="text" name="price_per_unit" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/4 w-full md:mb-0">
              <ValidationProvider vid="payment_terms" name="payment_terms" rules="required" v-slot="{ errors }">
                <small class="label">Payment term (Days)</small>
                <vs-input disabled v-model="form.prices.payment_terms" type="text" name="payment_terms" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/4 w-full md:mb-0">
              <ValidationProvider vid="delivery_terms" name="delivery_terms" rules="required" v-slot="{ errors }">
                <small class="label">Delivery term (Days)</small>
                <vs-input disabled v-model="form.prices.delivery_terms" type="text" name="delivery_terms" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>

          <div class="flex flex-wrap items-center justify-end">
            <vs-button v-if="form.status === 'Pending'"
              @click.stop="onChangeStatus('approve')" class="ml-auto mt-2">Accept</vs-button>
            <vs-button v-if="form.status === 'Pending'"
              @click.stop="onChangeStatus('reject')" class="ml-4 mt-2" type="border" color="danger">Reject</vs-button>
            <vs-button v-if="form.status === 'Pending'"
              @click.stop="onChangeStatus('cancel')" class="ml-4 mt-2" type="border" color="warning">cancel</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
    <vs-prompt
      @cancel="status_change_obj={}"
      @accept="changePriceChangeRequestStatus"
      @close="activePrompt = false"
      :title="status_change_obj.status === 'approve' ? 'Approve price request' : status_change_obj.status === 'reject' ? 'Reject price request' : 'Cancel price request'"
      :accept-text="'Submit'"
      :color="status_change_obj.status === 'approve' ? 'primary' : 'danger'"
      :active.sync="activePrompt">
      <div class="con-exemple-prompt">
        <span>Status change reason</span>
        <vs-input v-model="status_change_obj.status_reason" class="mt-3 w-full" />
      </div>
    </vs-prompt>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'

  function initialState() {
    return {
      open: false,
      raw_material_id: null,
      id: '',
      old_data: {},
      activePrompt: false,
      status_change_obj: {
        status: '',
        status_reason: ''
      },
      form: {
        prices: {
          price_per_unit: null,
          payment_terms: null,
          delivery_terms: null
        },
        prices_tier: [
          {min_order_quantity: '', max_order_quantity: '', price_per_unit: '', payment_terms: '',  delivery_terms: ''},
          {min_order_quantity: '', max_order_quantity: '', price_per_unit: '', payment_terms: '',  delivery_terms: ''}
        ],
        is_volume_price_tiers: false,
      },
    }
  }

export default {
  name: 'CreateRawMaterialPriceRequestPopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id, old_data) {
      try {
        Object.assign(this.$data, initialState())
        this.id = id
        this.old_data = old_data
        await this.fetchPriceChangeRequest()
        this.open = true;
      } catch (error) {
        this.$vs.loading.close()

      }
    },
    async fetchPriceChangeRequest() {
      try {
        const { data } = ( await SupplierRawMaterialRepository.getPriceChangeRequestDetails(this.id)).data
        this.form = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    addPriceTier() {
      this.form.prices_tier.push(
        {min_order_quantity: '', max_order_quantity: '', price_per_unit: '', payment_terms: '',  delivery_terms: ''}
      )
    },
    addVolumnPriceTier() {
      this.form.contract_prices_tier.push(
        {min_order_quantity: '', max_order_quantity: '', price_per_unit: '', payment_terms: '',  delivery_terms: ''}
      )
    },
    deleteVolumnPriceTier(index) {
      this.form.contract_prices_tier.splice(index, 1)
    },
    deleteProceTier(index) {
      this.form.prices_tier.splice(index, 1)
    },
    validate_prices_tier(index) {
      let previousIndex = index - 1
      return `min_than:@${index}max_order_quantity|cross_over_max:@${previousIndex}max_order_quantity|required`
    },
    validate_max_price_tier(index) {
      return `max_than:@${index}min_order_quantity|required`
    },
    validate_contract_prices_tier(index) {
      let previousIndex = index - 1
      return `min_than:@${index}volume_price_tiers_max_order_quantity|cross_over_max:@${previousIndex}volume_price_tiers_max_order_quantity|required`
    },
    validate_max_contract_price_tier(index) {
      return `max_than:@${index}volume_price_tiers_min_order_quantity|required`
    },
    async changePriceChangeRequestStatus() {
      try {
        await SupplierRawMaterialRepository.priceChangeRequestStatusChange(
          this.form.id, this.status_change_obj.status, { comment: this.status_change_obj.status_reason }
        )
        this.showSuccessMessage('Price change request status changed successfully')
        this.$emit('refreshData', '')
        this.activePrompt = false
        this.open = false;
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onChangeStatus(status) {
      this.open = false
      this.status_change_obj.status = status
      this.activePrompt = true
    }
  },
  components: {
    flatPickr
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.rm-price-change-request-create-popup >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 70% !important;
}
</style>
